import { useContext } from 'react';

import { useVirtualLogin } from 'src/contexts/virtual-login-context';

import { AuthContext } from '../context/auth-context';

export function useAuthContext() {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuthContext: Context must be used inside AuthProvider');
  }

  // Safely get virtual login context with fallback
  let virtualLoginData = {
    isVirtualLogin: false,
    virtualUser: null,
    virtualTokens: null,
    originalAdmin: null,
  };

  try {
    const virtualLoginContext = useVirtualLogin();
    if (virtualLoginContext) {
      virtualLoginData = {
        isVirtualLogin: virtualLoginContext.isVirtualLogin,
        virtualUser: virtualLoginContext.virtualUser,
        virtualTokens: virtualLoginContext.virtualTokens,
        originalAdmin: virtualLoginContext.originalAdmin,
      };
    }
  } catch (error) {
    // VirtualLoginProvider not available, use defaults
    console.warn('Virtual login context not available in useAuthContext, using defaults:', error.message);
  }

  const { isVirtualLogin, virtualUser, virtualTokens, originalAdmin } = virtualLoginData;

  const finalUser = isVirtualLogin ? {
    ...virtualUser,
    // Use virtual tokens when virtual login is active
    accessToken: virtualTokens?.accessToken,
    refreshToken: virtualTokens?.refreshToken,
  } : context.user;

  return {
    ...context,
    // Override user with virtual user if virtual login is active
    user: finalUser,
    // Add virtual login state to context
    isVirtualLogin,
    originalAdmin,
    changeOrganization: context.changeOrganization,
  };
}
